import { __assign, __makeTemplateObject, __read, __rest, __spread } from "tslib";
import React, { forwardRef } from 'react';
import { Droppable as RBDDroppable, } from 'react-beautiful-dnd';
import { styled, useThemeProps } from '../../../foundation';
var _RcDroppable = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDroppable' });
    var children = props.children, rest = __rest(props, ["children"]);
    return (React.createElement(RBDDroppable, __assign({}, rest, { ref: ref }), function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return children.apply(void 0, __spread(args));
    }));
});
var RcDroppable = styled(_RcDroppable)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcDroppable.defaultProps = {};
RcDroppable.displayName = 'RcDroppable';
export { RcDroppable };
var templateObject_1;
